import { createContext, useContext, useEffect, useMemo, useState } from "react";
import { toast } from "sonner";
import { useGet } from "./api";

const Ctx = createContext(null);
const load = (k) => { try { return JSON.parse(localStorage.getItem(k)) || []; } catch { return []; } };

export function ShopProvider({ children }) {
  const [cart, setCart] = useState(() => load("dt_cart"));
  const [wish, setWish] = useState(() => load("dt_wish"));
  const [coupon, setCoupon] = useState(() => localStorage.getItem("dt_coupon") || "");
  const { data: settings = {} } = useGet("/settings");

  useEffect(() => { localStorage.setItem("dt_cart", JSON.stringify(cart)); }, [cart]);
  useEffect(() => { localStorage.setItem("dt_wish", JSON.stringify(wish)); }, [wish]);
  useEffect(() => { localStorage.setItem("dt_coupon", coupon); }, [coupon]);

  const value = useMemo(() => ({
    cart, wish, coupon, setCoupon, settings,
    count: cart.reduce((s, i) => s + i.qty, 0),
    add(p, size, color, qty = 1) {
      const key = `${p.id}-${size}-${color}`;
      setCart((c) => c.find((i) => i.key === key)
        ? c.map((i) => (i.key === key ? { ...i, qty: Math.min(i.qty + qty, 50) } : i))
        : [...c, { key, product_id: p.id, slug: p.slug, title: p.title, image: p.images?.[0], price: p.effective_price || p.price, size, color, qty }]);
      toast.success(`${p.title} added to cart`, { description: `Size ${size}${color ? " · " + color : ""}` });
    },
    setQty: (key, qty) => setCart((c) => c.map((i) => (i.key === key ? { ...i, qty: Math.max(1, Math.min(qty, 50)) } : i))),
    remove: (key) => setCart((c) => c.filter((i) => i.key !== key)),
    clear: () => setCart([]),
    inWish: (id) => wish.some((w) => w.id === id),
    toggleWish(p) {
      setWish((w) => (w.some((x) => x.id === p.id) ? w.filter((x) => x.id !== p.id) : [...w, p]));
    },
  }), [cart, wish, coupon, settings]);

  return <Ctx.Provider value={value}>{children}</Ctx.Provider>;
}

export const useShop = () => useContext(Ctx);

export function useSeo(title, description) {
  useEffect(() => {
    document.title = title ? `${title} | DEN & THREADS` : "DEN & THREADS — Wear Your Vibe. Print Your Identity.";
    let m = document.querySelector('meta[name="description"]');
    if (!m) { m = document.createElement("meta"); m.name = "description"; document.head.appendChild(m); }
    m.content = description || "Premium Gen-Z streetwear, anime printed apparel, custom printing and wholesale from Kanpur, India.";
  }, [title, description]);
}
